/* ============
 * Routes File
 * ============
 *
 * The routes and redirects are defined in this file
 */


/**
 * The routes
 *
 * @type {object} The routes
 */
const home = resolve => {
	require.ensure(['./pages/home/index.vue'], ()=>{
		resolve(require('./pages/home/index.vue'))
	})
};
const login = resolve => {
	require.ensure(['./pages/login/index.vue'], ()=>{
		resolve(require('./pages/login/index.vue'))
	})
};
const signin = resolve => {
  require.ensure(['./pages/signin/index.vue'], ()=>{
    resolve(require('./pages/signin/index.vue'))
  })
};
const signup = resolve => {
	require.ensure(['./pages/signup/index.vue'], ()=>{
		resolve(require('./pages/signup/index.vue'))
	})
};
const forgot = resolve => {
	require.ensure(['./pages/forgotpass/index.vue'], ()=>{
		resolve(require('./pages/forgotpass/index.vue'))
	})
};
const coleccion = resolve => {
	require.ensure(['./pages/home_vert/index.vue'], ()=>{
		resolve(require('./pages/home_vert/index.vue'))
	})
};
const tipoComida = resolve => {
	require.ensure(['./pages/home_vert/index.vue'], ()=>{
		resolve(require('./pages/home_vert/index.vue'))
	})
};

const distrito = resolve => {
	require.ensure(['./pages/home_vert/index.vue'], ()=>{
		resolve(require('./pages/home_vert/index.vue'))
	})
};
const search = resolve => {
	require.ensure(['./pages/search/index.vue'], ()=>{
		resolve(require('./pages/search/index.vue'))
	})
};
const listall = resolve => {
	require.ensure(['./pages/listall/index.vue'], ()=>{
		resolve(require('./pages/listall/index.vue'))
	})
};
const filter = resolve => {
	require.ensure(['./pages/filter/index.vue'], ()=>{
		resolve(require('./pages/filter/index.vue'))
	})
};

const detail = resolve => {
	require.ensure(['./pages/restaurant/detail/index.vue'], ()=>{
		resolve(require('./pages/restaurant/detail/index.vue'))
	})
};

const comment = resolve => {
  require.ensure(['./pages/comment/index.vue'], ()=>{
    resolve(require('./pages/comment/index.vue'))
  })
};
const confirm = resolve => {
	require.ensure(['./pages/restaurant/confirm/index.vue'], ()=>{
		resolve(require('./pages/restaurant/confirm/index.vue'))
	})
};

const newcomment = resolve => {
	require.ensure(['./pages/restaurant/new_comment/index.vue'], ()=>{
		resolve(require('./pages/restaurant/new_comment/index.vue'))
	})
};

const reservations = resolve => {
	require.ensure(['./pages/account/reservations/index.vue'], ()=>{
		resolve(require('./pages/account/reservations/index.vue'))
	})
};

const reservationsEdit = resolve => {
	require.ensure(['./pages/account/reservations/edit/index.vue'], ()=>{
		resolve(require('./pages/account/reservations/edit/index.vue'))
	})
};

const profile = resolve => {
	require.ensure(['./pages/account/profile/index.vue'], ()=>{
		resolve(require('./pages/account/profile/index.vue'))
	})
};

const points = resolve => {
	require.ensure(['./pages/account/points/index.vue'], ()=>{
		resolve(require('./pages/account/points/index.vue'))
	})
};

const freepoints = resolve => {
	require.ensure(['./pages/account/freepoints/index.vue'], ()=>{
		resolve(require('./pages/account/freepoints/index.vue'))
	})
};

const faq = resolve => {
  require.ensure(['./pages/faq/index.vue'], ()=>{
    resolve(require('./pages/faq/index.vue'))
  })
};

export default [
  // Login
  {
    path: '/login',
    name: 'login',
    component: require('./pages/login/index.vue'),

    // If the user needs to be a guest to view this page
    meta: {
      guest: true,
    },
  },
  // Siginn
  {
    path: '/signin',
    name: 'signin',
    component: require('./pages/signin/index.vue'),

    // If the user needs to be a guest to view this page
    meta: {
      guest: true,
    },
  },
  // Signup
  {
    path: '/signup',
    name: 'signup',
    component: require('./pages/signup/index.vue'),

    // If the user needs to be a guest to view this page
    meta: {
      guest: true,
    },
  },
  // Forgot password
  {
    path: '/forgot',
    name: 'forgot',
    component: forgot,

    // If the user needs to be a guest to view this page
    meta: {
      guest: true,
    },
  },
  // Home
  {
    path: '/',
    name: 'home',
    component: home,
	},
  // Home vertical for group's sections
  {
    path: '/:lang*/coleccion/:id',
    name: 'coleccion',
    component: coleccion,
  },
  {
    path: '/:lang*/food/:id',
    name: 'tipoComida',
    component: tipoComida,
  },
  {
    path: '/:lang*/tipo-comida/:id',
    name: 'tipoComida',
    component: tipoComida,
  },
  {
    path: '/:lang*/distrito/:id',
    name: 'distrito',
    component: distrito,
  },
  // Home vertical for group's sections
  {
    path: '/search',
    name: 'search',
    component: search,
  },
  {
    path: '/listall',
    name: 'listall',
    component: listall,
  },
  {
    path: '/filter',
    name: 'filter',
    component: filter,
  },
  // Restaurant Detail
  {
    path: '/:lang*/restaurante/:id',
    name: 'rest.detail',
    component: detail,
  },
  // Restaurant Detail
  {
    path: '/:lang*/restaurant/:id',
    component: detail,
  },
  // Comment Detail
  {
    path: '/:lang*/comentario-de-comensal/:id',
    name: 'comment.detail',
    component: comment,
  },
  // Comment Detail
  {
    path: '/:lang*/customer-review/:id',
    component: comment,
  },

  // Confirm reservation
  {
    path: '/:lang*/restaurante/:id/confirm',
    name: 'rest.confirm',
    component: confirm,
    meta: {
      auth: true,
    },
  },
  // New Restaurant's comment
  {
    path: '/restaurante/:id/newcomment',
    name: 'rest.newcomment',
    component: newcomment,
    meta: {
      auth: false,
    },
  },
  // User's reservations
  {
    path: '/reservations',
    name: 'user.reservations',
    component: reservations,
    meta: {
      auth: true,
    },
  },
  // Edit User's reservations
  {
    path: '/reservations/:id',
    name: 'user.reservations.edit',
    component: reservationsEdit,
    meta: {
      auth: true,
    },
  },
  // User's profile
  {
    path: '/profile',
    name: 'user.profile',
    component: profile,
    meta: {
      auth: true,
    },
  },
  // User's points
  {
    path: '/points',
    name: 'user.points',
    component: points,
    meta: {
      auth: true,
    },
  },
  // Free points
  {
    path: '/free-points',
    name: 'user.freepoints',
    component: freepoints,
    meta: {
      auth: true,
    },
  },
  // Faq
  {
    path: '/faq',
    name: 'faq',
    component: faq,
    meta: {
      auth: false,
    },
  },
  {
    path: '/es',
    redirect: '/:lang?',
  },
  {
    path: '/en',
    redirect: '/:lang?',
  },
];



// WEBPACK FOOTER //
// ./src/app/routes.js